<template>
  <label>
    {{ label }}
    <v-select
        :options="options"
        label="value"
        v-model="val"
        :multiple="multiple"
        @blur="blur"
        @click="click"
        :disabled="disabled"
    >
      <template slot="no-options">
        Нет совпадений
      </template>
      <!--div slot="no-options">По вашему запросу нет результатов</div-->
    </v-select>
  </label>
</template>
<script>

export default {
  name: 'CustomSelect',
  props: {
    options: {
      type: Array,
      default: null
    },
    value: {
      default: null
    },
    element: {
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: null,
    }
  },
  mounted() {
    this.val = this.value;
    console.log(this.val);
  },
  methods: {
    blur(event) {
      console.log('blur', event);
      this.$emit('blur', event)
    },
    click(event) {
      console.log('click', event);
      this.$emit('click', event.target.value)
    },
  },
  watch: {
    val() {
      this.$emit('update:element', this.val);
    },
    value() {
      this.val = this.value;
      this.$emit('update:element', this.val);
    }
  }
}
</script>

<style scoped>
label {
  width: 100%;
  font-weight: 600;
  color: #565656;
  margin-bottom: 15px;
  font-size: 0.85rem;
}
</style>

<style>
.vs__dropdown-toggle {
  border-radius: 7px;
  background-color: #fff;
}
</style>
